import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import 'moment/locale/de';

import { LANG } from '../util-app-config';

@Pipe({
  name: 'fromNow',
  standalone: true,
})
export class FromNowPipe implements PipeTransform {
  public transform(value: string): string {
    const diffMonths = moment().diff(value, 'months');
    const language = localStorage.getItem(LANG) ?? 'de';
    moment.locale(language);

    if (diffMonths >= 1) {
      return new DatePipe(language).transform(value, 'mediumDate');
    } else {
      return moment(value).fromNow();
    }
  }
}
